"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assessCanonicalRealtimeScoringCanary = void 0;
const migration_assessment_1 = require("./migration-assessment");
const canonicalJson = (value) => {
    if (Array.isArray(value))
        return `[${value.map(canonicalJson).join(',')}]`;
    if (typeof value === 'object' && value !== null) {
        return `{${Object.entries(value)
            .sort(([left], [right]) => left.localeCompare(right))
            .map(([key, nested]) => `${JSON.stringify(key)}:${canonicalJson(nested)}`)
            .join(',')}}`;
    }
    return JSON.stringify(value);
};
/**
 * Checks whether a V1 definition is an exact, source-equivalent translation
 * of a legacy structured filter. This deliberately excludes semantic changes
 * and all legacy scoring weights from the first production cutover cohort.
 */
const assessCanonicalRealtimeScoringCanary = (configuration, definition) => {
    if (configuration === undefined) {
        return {
            eligible: false,
            blockers: [...(definition === undefined ? ['missing_definition'] : []), 'unsupported_legacy_behavior'],
        };
    }
    const assessment = (0, migration_assessment_1.assessLegacyHeatFilterForRealtimeScoring)(configuration);
    const blockers = [];
    if (definition === undefined)
        blockers.push('missing_definition');
    if (assessment.requiresManualTranslation)
        blockers.push('unsupported_legacy_behavior');
    if (assessment.findings.some((finding) => finding.disposition === 'semantic_change')) {
        blockers.push('semantic_change');
    }
    if (definition !== undefined &&
        (assessment.suggestedDefinition === undefined ||
            canonicalJson(definition) !== canonicalJson(assessment.suggestedDefinition))) {
        blockers.push('definition_differs_from_legacy');
    }
    return { eligible: blockers.length === 0, blockers };
};
exports.assessCanonicalRealtimeScoringCanary = assessCanonicalRealtimeScoringCanary;
//# sourceMappingURL=canonical-canary.js.map